import * as FaIcons from "react-icons/fa";
import "../Sidebar.scss";
import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import { Button, Offcanvas, OffcanvasBody, OffcanvasHeader } from "reactstrap";
import Logo from "../img/logo.png";

const SidebarAdm = () => {
  //OffCanvas
  const [isOpen, setIsOpen] = useState(false);

  const toggleOffCanvas = () => {
    setIsOpen(!isOpen);
  };

  //
  const menuItem = [
    {
      path: "Administrador",
      name: "Dashboard",
      icon: <FaIcons.FaFlipboard />,
    },
    {
      path: "usuarios",
      name: "Becarios",
      icon: <FaIcons.FaUsers />,
    },
    {
      path: "postulantes",
      name: "Postulantes",
      icon: <FaIcons.FaUserPlus />,
    },
    {
      path: "usuarios-adm",
      name: "Personal",
      icon: <FaIcons.FaUserTie />,
    },
    {
      path: "usuarios-grad",
      name: "Graduados",
      icon: <FaIcons.FaUserGraduate />,
    },
    {
      path: "Administrador-Sistema",
      name: "Adm-Sistema",
      icon: <FaIcons.FaUsersCog />,
    },
    {
      path: "informe2",
      name: "Informes",
      icon: <FaIcons.FaEnvelopeOpenText />,
    },
    {
      path: "cargara",
      name: "Cargar Documentos",
      icon: <FaIcons.FaFileUpload />,
    },
    {
      path: "gestion",
      name: "Gestión Usuarios",
      icon: <FaIcons.FaUserTag />,
    },
  ];
  return (
    <div>
      <div>
        <Button onClick={toggleOffCanvas} className="bars">
          <FaIcons.FaBars />
        </Button>
      </div>
      <Offcanvas isOpen={isOpen} toggle={toggleOffCanvas} className="sidebar">
        <OffcanvasHeader toggle={toggleOffCanvas}>
          <div>
            <h1 className="logo">
              <img
                src={Logo}
                alt="logo"
                // className="rounded-circle me-2"
                style={{
                  height: 100,
                  width: 100,
                }}
              />
            </h1>
          </div>
        </OffcanvasHeader>
        <OffcanvasBody>
          {menuItem.map((item, index) => (
            <NavLink
              end
              className={({ isActive }) =>
                `link text-light py-3 w-100 px-2 ${isActive ? "active" : ""}`
              }
              to={item.path}
              key={index}
            >
              <div className="icon me-2">{item.icon}</div>
              <div
                style={{ display: isOpen ? "block" : "none" }}
                className="link_text"
              >
                {item.name}
              </div>
            </NavLink>
          ))}
        </OffcanvasBody>
      </Offcanvas>
    </div>
  );
};

export default SidebarAdm;
